module.exports = __webpack_public_path__ + "img/img-plan-index.2da92c1f.png";